import { type ReduxUser, type CommunityBase } from 'models';
import { canManageCommunity } from './canManageCommunity';

export const canViewCommunityMembers = ({ viewer, community }: { viewer: ReduxUser; community: CommunityBase }) =>
  Boolean(community.settings.viewMembers) || canManageCommunity({ viewer, community });
